/**
 * Auth0 Provider wrapper for the public site
 */
import React from 'react';
import { Auth0Provider, AppState } from '@auth0/auth0-react';
import { useNavigate } from 'react-router-dom';
import { auth0Config, isAuth0Configured } from '../../config/auth0';

interface AuthProviderProps {
  children: React.ReactNode;
}

export function AuthProvider({ children }: AuthProviderProps) {
  const navigate = useNavigate();

  // If Auth0 is not configured, just render children without auth
  if (!isAuth0Configured()) {
    return <>{children}</>;
  }

  const onRedirectCallback = (appState?: AppState) => {
    // Navigate to the returnTo path or stay on current page
    navigate(appState?.returnTo || window.location.pathname, { replace: true });
  };

  return (
    <Auth0Provider
      domain={auth0Config.domain}
      clientId={auth0Config.clientId}
      authorizationParams={{
        redirect_uri: window.location.origin,
        audience: auth0Config.audience,
        scope: 'openid profile email',
      }}
      cacheLocation="localstorage"
      onRedirectCallback={onRedirectCallback}
    >
      {children}
    </Auth0Provider>
  );
}

export default AuthProvider;
